<template>
  <div class="card" v-if="currentCardId == 'reason'">
    <ReasonCard
      :format-id="formatId"
      :example-sentences="exampleSentences"
      :textarea-min-rows="textareaMinRows"
      :preview-errors="previewErrors"
      :format-data="formatData"
      :current-card-id="currentCardId"
      @update:reason="(value) => (formatData.reason = value)"
      @update-format-field="formatData[$event.key] = $event.value"
    />
  </div>
</template>

<script setup lang="ts">
import ReasonCard from '@/components/yagiprime/ReasonCard.vue'
import {
  useRirekishoFormatData,
  type RirekishoExampleSentences
} from '@/composables/format-edit/useRirekishoFormatData'

defineProps<{
  currentCardId?: string
  formatId?: string
  exampleSentences?: RirekishoExampleSentences
  textareaMinRows: number
  previewErrors: Record<string, string>
}>()

const formatData = useRirekishoFormatData()
</script>
